export default __webpack_public_path__ + "static/media/logo_short.91c92be1.png";